export enum LayoutActionTypes {
  SET_COLLAPSED_NAVBAR = '@@layout/SET_COLLAPSED_NAVBAR',
}

export interface ILayoutState {
  readonly collapsedNavbar: boolean;
}
